<template>
  <v-row>
    <v-col cols="12">
      <v-data-table
        :headers="headers"
        :items="tableData"
        :items-per-page="item.rowsPerPage"
        :dense="true"
        hide-default-footer
        must-sort
        class="sub-table eg-table-bnone eg-table-td-py-md pt-2 rounded-0 mainText--text"
        @update:sort-by="sortBy"
        @update:sort-desc="changeSortDesc"
      >
        <template v-if="selectable" v-slot:header.checked="{ header }">
          <v-checkbox v-model="renewAll">
            <template v-slot:label>
              <span style="font-size: 11px;">Renew All</span>
            </template>
          </v-checkbox>
        </template>
        <template v-slot:item.name="{item}">
            {{ item.name || '-' }}
        </template>
        <template v-slot:item.network="{item}">
          {{ item.network || '-' }}
        </template>
        <template v-slot:item.expiration_date="{item}">
          {{ util.formatDate(item.expiration_date) }}
        </template>
        <template v-slot:item.model="{item}">
          <span class="font-weight-bold">{{ item.model }}</span>
        </template>
        <template v-if="selectable" v-slot:item.checked="{item}">
          <v-simple-checkbox
            :ripple="false"
            color="primary"
            v-model="item.checked"
          ></v-simple-checkbox>
        </template>
      </v-data-table>
    </v-col>

    <v-col cols="12" class="mb-4">
      <pagination
        v-model="item.currentPage"
        :total-records="item.totalRecords"
        :default-rows-per-page="item.rowsPerPage"
        @load-data="loadData"
        @set-rows-per-page="setRowsPerPage"
      />
    </v-col>
  </v-row>
</template>

<script>
import util from '@/util'

import Pagination from './Pagination'

export default {
  name: 'LicenseManagementSubTable',
  components: {
    Pagination,
  },

  props: {
    item: {
      type: Object,
    },
    selectable: {
      type: Boolean,
    },
  },

  computed: {
    tableData() {
      return this.item.subData || []
    },
    headers () {
      const headers = [
        { text: 'Network', value: 'network', cellClass: 'py-4 pa-0', class: 'pl-0' },
        { text: 'Model', value: 'model', cellClass: 'py-4 pa-0', class: 'pl-0' },
        { text: 'Name', value: 'name', cellClass: 'py-4 pa-0', class: 'pl-0' },
        { text: 'Serial Number', value: 'serial_number', cellClass: 'py-4 pa-0', class: 'pl-0' },
        { text: 'License Expires', value: 'expiration_date', cellClass: 'py-4 pa-0', class: 'pl-0' },
      ];
      if (this.selectable) {
        headers.push({ text: 'Renew', value: 'checked', cellClass: 'py-4 pa-0', class: 'pl-0', sortable: false });
      }
      return headers;
    },
    renewAll: {
      get() {
        return this.tableData.every(el => el.checked);
      },
      set(newVal) {
        this.item.subData = this.item.subData.map(el => ({...el, checked: newVal}));
      }
    }

  },

  data() {
    return {
      util: util,
      sortKey: '',
      isSortDesc: false,
    }
  },

  methods: {
    setRowsPerPage(rowsPerPage) {
      this.$emit('load-data', {
        currentPage: 1,
        rowsPerPage,
        sortKey: this.sortKey,
        isSortDesc: this.isSortDesc,
      })
    },

    loadData(currentPage) {
      this.$emit('load-data', {
        currentPage,
        rowsPerPage: this.item.rowsPerPage,
        sortKey: this.sortKey,
        isSortDesc: this.isSortDesc,
      })
    },

    sortBy(sortKeys) {
      this.sortKey = sortKeys[0]
      this.isSortDesc = false

      this.$emit('load-data', {
        currentPage: this.item.currentPage,
        rowsPerPage: this.item.rowsPerPage,
        sortKey: this.sortKey,
        isSortDesc: this.isSortDesc,
      })
    },

    changeSortDesc(sortKeysDesc) {
      this.isSortDesc = sortKeysDesc[0]

      this.$emit('load-data', {
        currentPage: this.item.currentPage,
        rowsPerPage: this.item.rowsPerPage,
        sortKey: this.sortKey,
        isSortDesc: this.isSortDesc,
      })
    },
  }
}
</script>
